import { request } from "."

export const programsApi = {
  getAll() {
    return request("/api/programs")
  },
  getStages() {
    return request(`/api/stages`)
  },
  getStudents(programId: string) {
    return request(`/api/programs/${programId}/students`)
  },
  getReports(teamId: string) {
    return request(`/api/teams/${teamId}/reports`)
  },
  getAnalitics(programId: string) {
    return request(`/api/programs/${programId}/analitics`)
  },

  addProgram(formData: FormData) {
    return request(`/api/programs`, formData)
  },
  editProgram(programId: string, formData: FormData) {
    return request(`/api/programs/${programId}`, formData)
  },
  addTeam(programId: string, values: any) {
    return request(`/api/programs/${programId}/teams`, values)
  },
  editTeam(teamId: string, programId: string, values: any) {
    return request(`/api/programs/${programId}/teams/${teamId}`, values)
  },

  completeReportRequest(reportId: string) {
    return request(`/api/reports/${reportId}/accept`, {})
  },
  cancelReportRequest(reportId: string) {
    return request(`/api/reports/${reportId}/decline`, {})
  },
  
  getTransfers(programId: string) {
    return request(`/api/programs/${programId}/transfers`)
  }
}